<!-- Desktop -->
@if (showSpinner) {
  <div class="spinner-container"><app-spinner class="spinner"></app-spinner></div>
}
@if (!isMobile()) {
  <div class="container">
    <div  class="back-link mb-3 mb-sm-0">
      @if (backLink$ | async; as backLink) {
        <a
          [routerLink]="backLink.targetUri"
          class="d-inline-flex"
          data-track-elem="button"
          [attr.data-track-name]="backLink.text"
          >
          <i class="allycon-glyph-chevron-left" aria-hidden="true"></i>
          <span>{{ getBackLinkTranslation(backLink.text) }}</span>
        </a>
      }
    </div>
    <div class="vehicle-header">
      <h1>{{postingTypeString}}</h1>
      <div class="vehicle-header__info">
        {{updatedPostingVehicleDescription}}
      </div>
      <div class="vehicle-header__vin">
        {{vehicleVin}}
      </div>
    </div>
    <div class="edit-posting-content">
      <div class="sidebar-container">
        <app-edit-posting-nav [disableLinksForHold]="disableLinksForHold"></app-edit-posting-nav>
      </div>
      <div class="form-container">
        @if (disableLinksForHold) {
          <div class="form-content">
            <div class="processing-banner">
              <em class="allycon-warning warning-icon"></em> {{editPostingTranslations.textVehiclePending}}
            </div>
          </div>
        }
        <div class="form-title">
          {{selectedFormHeader}}
        </div>
        @if (!postingData) {
          <div class="form-content">
            <lib-posting-skeleton></lib-posting-skeleton>
          </div>
        }
        @if (postingData) {
          <div class="form-content">
            @if (postingData) {
              @if (selectedForm == editPostingForms.INFO_DESCRIPTION) {
                <app-description-form
                  (vehicleHeaderHelper)="vehicleHeaderHelper()"
                  [postingTypeString]="analyticsPostingTypeString">
                </app-description-form>
              }
            }
            @if (selectedForm == editPostingForms.INFO_LOCATION) {
              <app-location-form
                [postingTypeString]="analyticsPostingTypeString">
              </app-location-form>
            }
            @if (selectedForm == editPostingForms.OPTIONS_EXTERIOR) {
              <app-exterior-form
                [postingTypeString]="analyticsPostingTypeString">
              </app-exterior-form>
            }
            @if (selectedForm == editPostingForms.OPTIONS_INTERIOR) {
              <app-interior-form
                [postingTypeString]="analyticsPostingTypeString">
              </app-interior-form>
            }
            @if (selectedForm == editPostingForms.OPTIONS_MECHANICAL) {
              <app-mechanical-form
                [postingTypeString]="analyticsPostingTypeString">
              </app-mechanical-form>
            }
            @if (selectedForm == editPostingForms.OPTIONS_ADDITIONAL) {
              <app-full-description-form
                [postingTypeString]="analyticsPostingTypeString">
              </app-full-description-form>
            }
            @if (selectedForm == editPostingForms.IMAGES_PHOTOS) {
              <app-photos-form
                [postingTypeString]="analyticsPostingTypeString">
              </app-photos-form>
            }
            @if (selectedForm == editPostingForms.DISCLOSURES_CONDITION) {
              <app-condition-form
                (yellowLightEvent)="yellowLightSelected($event)"
                [postingTypeString]="analyticsPostingTypeString">
              </app-condition-form>
            }
            @if (selectedForm == editPostingForms.DISCLOSURES_DAMAGES) {
              <app-damages-form
                [postingTypeString]="analyticsPostingTypeString">
              </app-damages-form>
            }
            @if (selectedForm == editPostingForms.DISCLOSURES_TIRES) {
              <app-tires-form
                [postingTypeString]="analyticsPostingTypeString">
              </app-tires-form>
            }
            @if (selectedForm == editPostingForms.DISCLOSURES_ADDITIONAL) {
              <app-additional-disclosures-form
                [postingTypeString]="analyticsPostingTypeString">
              </app-additional-disclosures-form>
            }
            @if (selectedForm == editPostingForms.PRICING_PRICING_AND_FEES) {
              <app-pricing-and-fees-form
                [postingTypeString]="analyticsPostingTypeString">
              </app-pricing-and-fees-form>
            }
          </div>
        }
        @if (postingData) {
          <app-edit-posting-buttons
            [isYellowLightChecked]="isYellowLightChecked"
            (continueSubmission)="showPostingSuccessModal($event)"
          ></app-edit-posting-buttons>
        }
      </div>
    </div>
  </div>
}

<!-- Mobile -->
@if (isMobile()) {
  <div class="container">
    <div  class="back-link mb-3 mb-sm-0">
      @if (backLink$ | async; as backLink) {
        <a
          [routerLink]="backLink.targetUri"
          class="d-inline-flex"
          data-track-elem="button"
          [attr.data-track-name]="backLink.text"
          >
          <i class="allycon-glyph-chevron-left" aria-hidden="true"></i>
          <span>{{ getBackLinkTranslation(backLink.text) }}</span>
        </a>
      }
    </div>
    <div class="vehicle-header">
      <h1>{{postingTypeString}}</h1>
      <div class="vehicle-header__info">
        {{updatedPostingVehicleDescription}}
      </div>
      <div class="vehicle-header__vin">
        {{vehicleVin}}
      </div>
    </div>
    @if (postingData) {
      <app-edit-posting-mobile
        (continueSubmission)="showPostingSuccessModal($event)"
        [disableLinksForHold]="disableLinksForHold"
      ></app-edit-posting-mobile>
    }
  </div>
}

<!-- Content Card Templates -->

<app-modal [modalId]="'unsavedChangesModal'">
  <div class="modal-close-container">
    <button
      id="pf_close_x_button"
      class="modal__close"
      data-track-name="Close"
      [attr.aria-label]="editPostingTranslations.modalClose"
      (click)="continueEditing()"
      >
      <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
    </button>
  </div>

  <header class="modal__header">
    <h1 class="modal__title text-brand"  tabindex="-1" aria-hidden="true">
      {{editPostingTranslations.textWantToLeave}}
    </h1>
  </header>

  <div class="modal__content">
    <div class="modal__body">
      @if (postingType === postingTypes.NEW) {
        <p>
          {{editPostingTranslations.textLeaveNowNewPost}}
        </p>
      }
      @if (postingType !== postingTypes.NEW) {
        <p>
          {{editPostingTranslations.textLeaveNow}}
        </p>
      }
      <div class="modal__actions">
        <button
          class="btn btn-destructive mb-3 mb-md-0"
          data-track-elem="button"
          data-track-name="Don't Save Changes"
          (click)="cancelEditing()"
          >
          {{editPostingTranslations.btnExit}}
        </button>
        <button
          data-track-elem="button"
          data-track-name="Continue Editing"
          class="btn btn-link cancel-btn me-md-2"
          (click)="continueEditing()"
          >
          {{postingType !== postingTypes.NEW ? editPostingTranslations.btnContinueEditing : editPostingTranslations.btnGoBack}}
        </button>
      </div>
    </div>
  </div>
</app-modal>

<app-posting-success-modal
  [heading]="modalHeading"
  [content]="modalContent"
  [postingType]="postingType"
  [warningContent]="modalWarningContent"
  [vin]="vehicleVin"
  [inspectionType]="selectedInspectionOption">
</app-posting-success-modal>
